import * as angular from "angular";
import {ExpenseQueryRequest} from "../models/expense-query-request.model";
import {ExpensesExportQueryRequest} from "../models/expenses-export-query-request.model";
import {IQService} from "angular";
import {ExpensesAlerts} from "./expenses-alerts.service";
import {ExpensesRequests} from "./expenses-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ExpensesService {

  constructor(private $q: IQService, private expensesRequests: ExpensesRequests, private bringozLoaderService: BringozLoaderService, private $log, private expensesAlerts: ExpensesAlerts) {
  }

  getOne(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.getOne(id)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.expensesAlerts.getOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createExpense(expense) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.createExpense(expense)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.expensesCreateSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.expensesCreateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateExpense(expense) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.updateExpense(expense)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.expensesEditSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.expensesEditError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  approveExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.approveExpenses(expenseQueryRequest)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.approveExpensesSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.approveExpensesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  declineExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.declineExpenses(expenseQueryRequest)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.declineExpensesSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.declineExpensesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteExpenses(expenseIds:string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.deleteExpenses(expenseIds)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.deleteExpensesSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.deleteExpensesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportExpenses(expensesExportQueryRequest: ExpensesExportQueryRequest) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.exportExpenses(expensesExportQueryRequest)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.exportExpensesSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.exportExpensesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getExpenseTimeLine(expenseId: string, from?: number, to?: number) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesRequests.getExpenseTimeLine(expenseId,from,to)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.expensesAlerts.getExpenseTimeLineError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.expenses')
  .service('expensesService', ExpensesService);
